<form nz-form nzLayout="vertical" [formGroup]="formGroup()">
  <nz-form-item>
    <nz-form-label [nzRequired]="required()">
      {{ 'global.address' | translate }}
    </nz-form-label>
    <nz-form-control [nzErrorTip]="'global.address' | fieldValidationMsg">
      <nz-input-group [nzSuffix]="inputClearTpl">
        <input
          #autocomplete
          nz-input
          formControlName="autocomplete"
          [placeholder]="placeholder()"
        />
      </nz-input-group>
    </nz-form-control>
  </nz-form-item>
</form>

<ng-template #inputClearTpl>
  @if (autocomplete.value) {
    <span
      nz-icon
      class="ant-input-clear-icon"
      nzTheme="fill"
      nzType="close-circle"
      aria-hidden="true"
      (click)="onClearField()"
    ></span>
  }
</ng-template>
